import { useState } from "react";
import { Colors, Spacing } from "~/jsx/theme";
import { XButton } from "./XButton";
import { XModal } from "./XModal";
import { XTypography } from "./XTypography";
import { useModal } from "~/utils";

export const XDesignModal = ({
  title,
  canHide = false,
  children,
  ...modalProps
}: Parameters<typeof XModal>[0] & {
  title?: React.ReactNode;
  canHide?: boolean;
}) => {
  const [hiddenRaw, setHidden] = useState(false);
  const { isModalVisible } = useModal(modalProps.name);
  const finalVisible = modalProps.visible ?? isModalVisible;
  const hidden = hiddenRaw && canHide;

  return (
    <XModal
      {...modalProps}
      style={{
        ...modalProps.style,
        ...(hidden
          ? { backgroundColor: "transparent", pointerEvents: "none" }
          : {}),
      }}
      contentStyle={{
        padding: Spacing.px24,
        backgroundColor: hidden ? "transparent" : Colors.common.white,
        ...modalProps.contentStyle,
      }}
    >
      {title && (
        <XTypography
          style={{
            opacity: hidden ? 0 : 1,
            fontSize: "24px",
            marginBottom: "1em",
          }}
        >
          {title}
        </XTypography>
      )}
      {canHide && (
        <XButton
          onClick={() => setHidden(!hidden)}
          style={{
            pointerEvents: finalVisible ? "auto" : "none",
            position: "absolute",
            top: Spacing.px24,
            right: Spacing.px24,
          }}
        >
          {hidden ? "Show" : "Hide"}
        </XButton>
      )}

      <div
        style={{
          opacity: hidden ? 0 : 1,
          pointerEvents: hidden ? "none" : "inherit",
        }}
      >
        {children}
      </div>
    </XModal>
  );
};
